module.exports = require("froala-editor/js/languages/fr.js");